<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.92188 6.77513C11.484 5.40829 14.0166 5.40829 15.5787 6.77513C17.1408 8.14196 17.1408 10.358 15.5787 11.7249C15.3068 11.9628 15.0056 12.1593 14.6851 12.3143C13.6909 12.7955 12.7503 13.6454 12.7503 14.75V15.75M24.75 12.75C24.75 19.3774 19.3774 24.75 12.75 24.75C6.12258 24.75 0.75 19.3774 0.75 12.75C0.75 6.12258 6.12258 0.75 12.75 0.75C19.3774 0.75 24.75 6.12258 24.75 12.75ZM12.75 19.75H12.76V19.76H12.75V19.75Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 26,
  color: "#C3993E",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
